import { type ISbStoryData } from '@storyblok/react'

import { type StoryblokPageContentType } from '../storyblokPageContentTypes'

const DEFAULT_ROBOTS_VALUE = 'index, follow, noodp'

export const storyAccessorGetSeoRobotsValueOrDefault = (
  story: ISbStoryData<StoryblokPageContentType>,
): string => {
  const { seoRobots } = story.content

  if (!seoRobots) {
    return DEFAULT_ROBOTS_VALUE
  }

  return seoRobots
}
